import styles from "./UserGuide.module.css";
import { ReactComponent as ClearHistory } from "../../assets/Clear_Chat_Icon.svg";
import { ReactComponent as StopGenerating } from "../../assets/Stop_Generating_Icon.svg";
import { ReactComponent as ThumbsUp } from "../../assets/Thumbs_Up_Icon.svg";
import { ReactComponent as ThumbsDown } from "../../assets/Thumbs_Down_Icon.svg";
import { ReactComponent as Copy } from "../../assets/Copy_Icon.svg";
import { ReactComponent as Regenerate } from "../../assets/Regenerate_Icon.svg";
import { ReactComponent as DownloadIcon }  from "../../assets/Download_Icon_White.svg";
import { ReactComponent as CloseIcon } from "../../assets/Close_Icon.svg";
import { ReactComponent as SendIcon } from "../../assets/Send_Icon.svg";
import { ReactComponent as SendIconActive } from "../../assets/Send_Icon_Active.svg";
import iconStyles from "../Answer/Answer.module.css";

import { useTranslation} from "../../state/LanguageProvider";

const UserGuide = () => {
    const { getTranslation } = useTranslation();

    return (
        <div>  
            <p>{getTranslation('ug_intro_paragraph_1')}</p>  
            <p>{getTranslation('ug_intro_paragraph_2')}</p>  
            <p>{getTranslation('ug_intro_paragraph_3')}</p>  
            <p><strong>{getTranslation('ug_examples_heading')}</strong></p>  
            <p>{getTranslation('ug_example_1')}</p>  
            <p>{getTranslation('ug_example_2')}</p>  
            <p>{getTranslation('ug_example_3')}</p>  
            <h2>{getTranslation('ug_features_heading')}</h2>
            <table className={styles.userGuideTable}>  
                <tbody>  
                <tr className={styles.headerRow}>  
                    <th className={styles.headerRowTextContainer}>  
                        <p className={styles.headerRowTextCentered}>  
                        <strong>{getTranslation('ug_table_header_active_state')}</strong>  
                        </p>  
                    </th>  
                    <th className={styles.headerRowTextContainer}>  
                        <p className={styles.headerRowTextCentered}>  
                        <strong>{getTranslation('ug_table_header_inactive_state')}</strong>  
                        </p>  
                    </th>  
                    <th className={styles.headerRowTextContainer}>  
                        <p>  
                        <strong>{getTranslation('ug_table_header_purpose')}</strong>  
                        </p>  
                    </th>  
                </tr>  
                <tr>  
                    <td>
                        <ClearHistory className={styles.ugImg} aria-hidden="true" fill="var(--primary-color)"/>
                    </td>  
                    <td className={styles.noHover}>{getTranslation('ug_not_available')}</td> 
                    <td>{getTranslation('ug_clear_chat_button')}</td>  
                </tr>  
                <tr>  
                    <td className={styles.noHover}>
                        <SendIconActive className={styles.ugImg} aria-hidden="true"/>
                    </td>
                    <td className={styles.noHover}>
                        <SendIcon className={styles.ugImg} aria-hidden="true"/>
                    </td>  
                    <td>{getTranslation('ug_send_button')}</td>  
                </tr>  
                <tr>  
                    <td className={styles.noHover}>
                        <StopGenerating className={styles.ugImg} aria-hidden="true" fill="var(--primary-color)"/>
                    </td>  
                    <td className={styles.noHover}>{getTranslation('ug_not_available')}</td>  
                    <td>{getTranslation('ug_stop_generating_button')}</td>  
                </tr>  
                <tr>  
                    <td className={styles.noHover}>{getTranslation('ug_not_available')}</td> 
                    <td className={styles.noHover}>
                        <Regenerate className={styles.ugImg} aria-hidden="true" fill="var(--primary-color)"/>
                    </td> 
                    <td>{getTranslation('ug_regenerate_response_button')}</td>  
                </tr>  
                <tr>  
                    <td className={styles.noHover}>
                        <div className={styles.activeIconContainer}>
                            <ThumbsUp className={styles.activeIcon} width="16" height="17" viewBox="0 0 16 17" />
                        </div>
                    </td>  
                    <td className={styles.noHover}>
                        <ThumbsUp className={styles.ugImg} aria-hidden="true"/>
                    </td>  
                    <td>{getTranslation('ug_thumbs_up_button')}</td>  
                </tr>  
                <tr>  
                    <td className={styles.noHover}>
                        <div className={styles.activeIconContainer}>
                            <ThumbsDown className={styles.ugImg} aria-hidden="true" width="16" height="17" fill="none"/>
                        </div>
                    </td>  
                    <td className={styles.noHover}>
                        <ThumbsDown className={styles.ugImg} aria-hidden="true"/>
                    </td>  
                    <td>{getTranslation('ug_thumbs_down_button')}</td>  
                </tr>  
                <tr>  
                    <td className={styles.noHover}>
                        <div className={styles.activeIconContainer}>
                            <Copy className={styles.ugImg} fill="none" aria-hidden="true"/>
                        </div>
                    </td>  
                    <td className={styles.noHover}>
                        <Copy className={styles.ugImg} aria-hidden="true"/>
                    </td>  
                    <td>{getTranslation('ug_copy_to_clipboard_button')}</td>  
                </tr>  
                <tr>  
                    <td className={styles.noHover}>
                        <div className={styles.activeIconContainer}>
                            <DownloadIcon className={styles.ugImg} aria-hidden="true"/>
                        </div>
                    </td>  
                    <td className={styles.noHover}>{getTranslation('ug_not_available')}</td>  
                    <td>{getTranslation('ug_download_source_button')}</td>  
                </tr>  
                <tr>  
                    <td className={styles.noHover}>
                        <CloseIcon className={styles.ugImg} aria-hidden="true" fill="var(--primary-color)"/>
                    </td>  
                    <td className={styles.noHover}>{getTranslation('ug_not_available')}</td>  
                    <td>{getTranslation('ug_close_citation_panel_button')}</td>  
                </tr>  
                </tbody>  
            </table>  
        </div>  
        
        );
};

export default UserGuide;

